module.exports = __webpack_public_path__ + "img/solution_institutionalcare_sys_de.613ce4a8.jpg";